var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.smAndDown)?_c('v-btn',{attrs:{"small":"","text":"","to":/presupuesto/ + _vm.numdoc,"target":"_blank"}},[_c('v-icon',{staticClass:"ml-5"},[_vm._v("mdi-share-variant")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }